<template>
  <section class="content-header">
    <h1>Trabajos no liquidados</h1>
  </section>

  <section class="content">
    <div class="box box-primary">
      <div class="box-body">
        <div class="row">
          <div class="col-md-3">
            <div class="form-group">
              <label for="compania">Compañía</label>
              <Dropdown v-model="companyia" inputId="compania"
                :options="companyias" optionLabel="nombre" optionValue="id_companyia"
                filter placeholder="Todas las compañías" class="w-100" />
            </div>
          </div>

          <div class="col-md-3">
            <div class="form-group">
              <label for="operario">Operario</label>
              <Dropdown v-model="operario" inputId="operario"
                :options="operarios" optionLabel="nombre" optionValue="id_operario"
                filter placeholder="Todos los operarios" class="w-100" />
            </div>
          </div>

          <div class="col-md-2">
            <div class="form-group">
              <label for="usuario">Usuario</label>
              <Dropdown v-model="usuario" inputId="usuario"
                :options="usuarios" optionLabel="nombre" optionValue="id_usuario"
                filter placeholder="Todos los usuarios" class="w-100" />
            </div>
          </div>

          <div class="col-md-2">
            <div class="form-group">
              <label for="fecha_inicio">Fecha inicio</label>
              <Calendar v-model="fechaInicio" inputId="fecha_inicio"
                dateFormat="dd/mm/yy" showIcon class="w-100" />
            </div>
          </div>

          <div class="col-md-2">
            <div class="form-group">
              <label for="fecha_fin">Fecha fin</label>
              <Calendar v-model="fechaFin" inputId="fecha_fin"
                dateFormat="dd/mm/yy" showIcon class="w-100" />
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <div class="botonera">
              <button class="btn btn-primary" @click="cargarInforme('pdf')" :disabled="generando">
                <i class="fa" :class="generando === 'pdf' ? 'fa-spinner fa-spin' : 'fa-file-pdf-o'"></i>
                Generar PDF
              </button>
              <button class="btn btn-success" @click="cargarInforme('xls')" :disabled="generando">
                <i class="fa" :class="generando === 'xls' ? 'fa-spinner fa-spin' : 'fa-file-excel-o'"></i>
                Generar Excel
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <form id="FormInforme" method="get" style="display:none"></form>
    <iframe name="iframeInforme" style="display:none"></iframe>
  </section>
</template>

<script>
import { PwgsApi } from '../../../services/PwgsApi';
import Dropdown from 'primevue/dropdown';
import Calendar from 'primevue/calendar';

export default {
  components: { Dropdown, Calendar },

  data() {
    const hoy = new Date();
    return {
      companyias: [],
      companyia: '0',
      operarios: [],
      operario: '0',
      usuarios: [],
      usuario: '0',
      fechaInicio: new Date(hoy.getFullYear(), hoy.getMonth(), 1),
      fechaFin: hoy,
      generando: false
    };
  },

  methods: {
    formatearFecha(fecha) {
      if (!fecha) return '';
      const d = String(fecha.getDate()).padStart(2, '0');
      const m = String(fecha.getMonth() + 1).padStart(2, '0');
      return `${d}/${m}/${fecha.getFullYear()}`;
    },

    // Este informe va por GET, no por POST, y el fichero real empieza
    // por mayúscula (el case del PHP lo tiene en minúscula)
    async cargarInforme(tipo) {
      const destino = tipo === 'pdf' ? 'VentanaInforme' : 'iframeInforme';
      if (tipo === 'pdf') window.open('', 'VentanaInforme');

      this.generando = tipo;
      try {
        let direccion = localStorage.getItem('direccion');
        if (direccion == 'null.pwgs.app') direccion = 'pwgs5.local';

        const form = document.getElementById('FormInforme');
        form.innerHTML = '';
        form.method = 'get';
        form.target = destino;
        form.action = 'https://' + direccion + '/Informe_trabajos_noliquidados.php';

        const anyadir = (nombre, valor) => {
          const i = document.createElement('input');
          i.type = 'hidden';
          i.name = nombre;
          i.value = valor;
          form.appendChild(i);
        };

        anyadir('companyia', this.companyia || '0');
        anyadir('operario', this.operario || '0');
        anyadir('usuario', this.usuario || '0');
        anyadir('fecha_inicio', this.formatearFecha(this.fechaInicio));
        anyadir('fecha_fin', this.formatearFecha(this.fechaFin));
        anyadir('Submit', tipo === 'pdf' ? 'Generar PDF' : 'Generar XLS');

        form.submit();
      } finally {
        this.generando = false;
      }
    },

    async cargarFiltros() {
      const api = new PwgsApi();
      const respuesta = await api.get('informes/Informe_trabajos_noliquidados');
      const filtros = respuesta.filtros || (respuesta.informes && respuesta.informes.filtros) || [];

      const fCompanyias = filtros.find(f => f.nombre_campo === 'id_companyia');
      const fOperarios = filtros.find(f => f.nombre_campo === 'id_operario');
      const fUsuarios = filtros.find(f => f.nombre_campo === 'id_usuario');

      // En este informe "todos" se envía como 0, no como cadena vacía
      this.companyias = fCompanyias ? fCompanyias.valores : [];
      if (this.companyias.length && this.companyias[0].id_companyia === '') {
        this.companyias[0] = { id_companyia: '0', nombre: 'Todas las compañías' };
      }
      this.companyia = '0';

      this.operarios = fOperarios ? fOperarios.valores : [];
      if (this.operarios.length && this.operarios[0].id_operario === '') {
        this.operarios[0] = { id_operario: '0', nombre: 'Todos los operarios' };
      }
      this.operario = '0';

      this.usuarios = fUsuarios ? fUsuarios.valores : [];
      if (this.usuarios.length && this.usuarios[0].id_usuario === '') {
        this.usuarios[0] = { id_usuario: '0', nombre: 'Todos los usuarios' };
      }
      this.usuario = '0';
    }
  },

  mounted() {
    this.cargarFiltros();
  }
};
</script>

<style scoped>
.form-group label {
  display: block;
  font-weight: 600;
  margin-bottom: 5px;
}

.w-100 :deep(.p-dropdown),
.w-100 :deep(.p-calendar),
.w-100 :deep(.p-inputtext) {
  width: 100%;
}

.botonera {
  display: flex;
  align-items: center;
  gap: 8px;
}
</style>